<template>
    <div class="property-selected" v-if="selected.territory_id">
        <div class="property-selected_info">
            <div class="property-selected__name">
                <span
                    >{{ translate('name_label') }}:<strong>{{
                        selected.name
                    }}</strong></span
                >
                <span>
                    {{ translate('eligibility_analysis_label') }}:
                    <div>
                        <i
                            v-if="selected.eligibility.verdict"
                            class="flow flow-verified eligible"
                        ></i>
                        <i
                            v-else
                            class="flow flow-warning-sign not-eligible"
                        ></i>
                    </div>
                    <strong
                        :class="
                            selected.eligibility.verdict
                                ? 'eligible'
                                : 'not-eligible'
                        "
                    >
                        {{
                            selected.eligibility.verdict
                                ? $t('contrato_rastreabilidade.words.eligible')
                                : $t(
                                      'contrato_rastreabilidade.words.not_eligible'
                                  )
                        }}
                    </strong>
                </span>
            </div>
            <div
                class="property-selected__data"
                :class="
                    selected.eligibility.verdict
                        ? ''
                        : 'property-selected__data__not-eligible'
                "
            >
                <div class="property-selected__data__space">
                    <span>
                        {{ translate('socio_environmental_diagnosis_label') }}:
                        <strong
                            :class="
                                selected.eligibility.verdict
                                    ? 'eligible'
                                    : 'not-eligible'
                            "
                        >
                            {{
                                selected.eligibility.verdict
                                    ? $t('contrato_rastreabilidade.words.agreed')
                                    : $t('contrato_rastreabilidade.words.disagreed')
                            }}
                        </strong>
                    </span>
                    <span>
                        {{ translate('distance_label') }}:
                        <strong class="eligible">
                            {{selected.eligibility.distance}}
                        </strong>
                    </span>
                    <span v-if="availableBalance.valid">
                        {{ translate('available_balance_label') }}:
                        <strong
                            :class="
                                availableBalance.valid
                                    ? 'eligible'
                                    : 'not-eligible'
                            "
                        >
                            {{
                                availableBalance.ton + ' t ' + "(" + availableBalance.sc + " sc)"
                            }}
                        </strong>
                    </span>
                </div>
                    <span>
                        <el-link
                            @click="showDialogEligibilityVisible()"
                            :underline="false"
                        >
                            {{ $t('contrato_rastreabilidade.words.view_details') }}
                            <i
                                class="el-icon-right el-icon--right"
                                style="font-weight: 900"
                            />
                        </el-link>
                    </span>
            </div>
        </div>
        <div class="property-selected__volume">
            <el-form-item :label="translate('volume_label')">
                <el-input v-model="selected.volume" @input="onlyNumbers" />
            </el-form-item>
        </div>
        <dialog-eligibility-analysis
            :data="selected"
            v-model="dialogEligibilityVisible"
        />
    </div>
</template>

<script>
import DialogEligibilityAnalysis from '@/modules/traceability-contract/views/components/dialog-eligibility-analysis/index.vue';
import { mapState } from 'vuex';

export default {
    name: 'property-selected',
    components: { DialogEligibilityAnalysis },
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            dialogEligibilityVisible: false
        };
    },
    computed: {
        selected: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        ...mapState('traceabilityContractModule', ['availableBalance'])
    },
    methods: {
        getLocale(locale, district = false) {
            const localeComplete = locale
                .split(' - ')
                .map(item => item.trim());
            return district ? localeComplete[0] : localeComplete[1];
        },
        showDialogEligibilityVisible() {
            const fullDistrict = JSON.parse(JSON.stringify(this.selected.district));
            this.selected.district = this.getLocale(fullDistrict, true);
            this.selected.department = this.getLocale(fullDistrict, false);
            this.dialogEligibilityVisible = true;
        },
        translate(key) {
            const base = 'contrato_rastreabilidade.messages.report_properties';
            return this.$t(`${base}.${key}`);
        },
        onlyNumbers() {
            this.selected.volume = this.selected.volume.replace(/\D/g, '');
        }
    }
};
</script>

<style scoped lang="scss">
.property-selected {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-column-gap: 16px;

    .property-selected_info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .property-selected__name {
            display: flex;
            gap: 20px;
            padding: 12px 0;

            span {
                display: flex;
                gap: 4px;
            }
        }

        .property-selected__data {
            background-color: #ebf4eb;
            border-radius: 4px;
            padding: 0 32px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            
            .property-selected__data__info {
                display: flex;
                gap: 15px;
            }

            strong {
                color: #27a72b;
                margin-left: 8px;
            }

            .el-link {
                color: #1989fa;
                font-weight: lighter;
            }

            a.el-link:not(.is-disabled):hover {
                color: var(--secondary-two);
            }

            a.el-link.is-disabled:hover {
                color: #c0c4cc;
                cursor: pointer !important;
            }
        }

        .property-selected__data__space {
            display: flex;
            gap: 20px;

            span {
                display: flex;
                gap: 0px;
            }
        }

        .property-selected__data__not-eligible {
            background-color: #f4ebeb;

            strong {
                color: #d9534f;
            }
        }
    }

    .property-selected__volume {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .eligible {
        color: #359138;
    }

    .not-eligible {
        color: #d9534f;
    }
}
</style>
